import { jsx as n, Fragment as s } from "@emotion/react/jsx-runtime";
import { OverriddenMenuList as h } from "./TabMenu.styled.js";
import { useTabsContext as i } from "../TabsContext.js";
const v = ({
  visible: o,
  closeMenu: t,
  sections: a
}) => {
  const {
    selected: r,
    onChange: d
  } = i();
  return /* @__PURE__ */ n(s, { children: o && /* @__PURE__ */ n(h, { sections: a, position: "bottom", isChecked: (e) => e.value !== void 0 && r === e.value, onChange: (e) => {
    e.value !== void 0 && d(e.value), t();
  } }) });
};
export {
  v as TabMenu
};
